import { PLAID_FALLBACK_PARAM } from '../constants';
/** True when the customer reached manual entry because Plaid could not complete. */
function isPlaidFallback(search) {
    return new URLSearchParams(search).get(PLAID_FALLBACK_PARAM) === '1';
}
export default isPlaidFallback;
